import React from 'react';

import { HtmlContent } from '@dndbeyond/character-components/es';
import { Background, BackgroundUtils } from '@dndbeyond/character-rules-engine/es';

interface Props {
    background: Background | null;
    onClick: () => void;
}
export default class BackgroundDetail extends React.PureComponent<Props> {
    handleBackgroundClick = (evt: React.MouseEvent): void => {
        const { onClick } = this.props;

        if (onClick) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            onClick();
        }
    };

    renderDefault = (): React.ReactNode => {
        return (
            <div className="ct-background__default">
                Your character's background feature will display in this section once chosen.
            </div>
        );
    };

    render() {
        const { background } = this.props;

        if (!background) {
            return this.renderDefault();
        }

        const name = BackgroundUtils.getName(background);
        const featureName = BackgroundUtils.getFeatureName(background);
        const featureDescription = BackgroundUtils.getFeatureDescription(background);

        return (
            <div className="ct-background" onClick={this.handleBackgroundClick}>
                <div className="ct-background__name">{name}</div>
                {featureName && (
                    <div className="ct-background__feature">
                        <div className="ct-background__feature-name">Feature: {featureName}</div>
                        <HtmlContent
                            className="ct-background__feature-description"
                            html={featureDescription ? featureDescription : ''}
                        />
                    </div>
                )}
            </div>
        );
    }
}
